import { getNuveiSpeiBankList } from "@actions/withdraw";
import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { getUser } from "@utils";
import React from "react";
import { Box, BoxTitle, BoxWrapper, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

export default class NuveiSpei extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			bankList: [],
			selectedBank: null,
			canForward: false,
		};
	}

	componentDidMount() {
		super.componentDidMount();
		this.loadBankList();
		this.checkRequiredFields();
	}

	componentDidUpdate(_, prevState) {
		if (
			prevState.selectedBank !== this.state.selectedBank ||
			prevState.beneficiary_number !== this.state.beneficiary_number ||
			prevState.selectedCurrency !== this.state.selectedCurrency ||
			prevState.stake !== this.state.stake
		) {
			this.checkRequiredFields();
		}
	}

	loadBankList = async () => {
		try {
			const res = await getNuveiSpeiBankList();

			if (res?.data) {
				let banks = [];
				if (typeof res.data === "object" && !Array.isArray(res.data)) {
					banks = Object.entries(res.data).map(([name, code]) => ({
						name: name,
						code: code.toString(),
					}));
				} else if (Array.isArray(res.data)) {
					banks = res.data;
				}

				this.setState({ bankList: banks });
			}
		} catch (error) {
			console.error("Failed to load bank list:", error);
		}
	};

	onSelectBank = (selectedOption) => {
		this.setState({ selectedBank: selectedOption });
	};

	onEnterValue = (field, e) => {
		this.setState({ [field]: e.target.value });
	};

	checkRequiredFields = () => {
		const { selectedBank, beneficiary_number, selectedCurrency, stake } = this.state;
		if (selectedBank && beneficiary_number && selectedCurrency && stake) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const { bankList, selectedBank } = this.state;

		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];

		if (bankList && bankList.length > 0) {
			bankList.forEach((bank) => {
				bankOptions.push({
					value: bank.code,
					label: bank.name,
				});
			});
		}

		const selectedBankValue = selectedBank
			? bankOptions.find((o) => o.value === selectedBank.value)?.value
			: "";

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "beneficiary_bank" })}>
						<Box>
							<BoxTitle>{translate("beneficiary_bank")}</BoxTitle>
							<PaymentSelect
								options={bankOptions}
								value={selectedBankValue}
								handleSelect={this.onSelectBank}
								placeholder={translate("PLEASE_SELECT")}
							/>
						</Box>
					</FormItem>
					<FormItem onRegister={() => this.registerField({ name: "beneficiary_number" })}>
						<Box>
							<BoxTitle>{translate("beneficiary_number")}</BoxTitle>
							<StakeInput
								placeholder="...................."
								type="text"
								onChange={this.onEnterValue.bind(this, "beneficiary_number")}
							/>
						</Box>
					</FormItem>
				</BoxWrapper>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { stake, selectedCurrency, beneficiary_number, selectedBank } = this.state;
		let withdrawData = {
			type: "Nuvei",
			method: "Spei",
			username: getUser().username,
			amount: {
				value: Number(stake),
				currency: selectedCurrency,
			},
			note: new Date(),
			beneficiary_bank: selectedBank?.value,
			beneficiary_number,
		};

		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		return super.render();
	}
}
